/// <amd-module name="Build/Queue-Panel/FormInputLabel" />
import * as React from "react";

export interface IFormInputLabelProps {
    primaryLabel: string;
    secondaryLabel: string
}

export const FormInputLabel: React.FunctionComponent<IFormInputLabelProps> = props => {
    const { primaryLabel, secondaryLabel } = props;

    return (
        <div className="flex-row variable-label-div">
            <div className="variable-label-primary-text">{primaryLabel}</div>
            <div className="variable-label-secondary-text secondary-text">{secondaryLabel}</div>
        </div>
    );
};
